import type { VueConstructor } from 'vue'

import metricScale from './metrics/metric-scale'
import metricValidator from './metrics/metric-validator'
import metricFeedback from './metrics/metric-feedback'
import fractionNumber from './fraction-number'
import limitTo from './limitTo'
import roundROM from './roundROM'
import exerciseState from './exercise-state'
import shDate from './sh-date'
import isNumber from './is-number'
import sortNumeric from './sort-numeric'
import sortAlphabetically from './sort-alphabetically'
import sortByDate from './sort-by-date'
import sessionAndExerciseDuration from './session-duration'
import unitSystemFilters from './unit-system-filters'
import parsePhoneNumber from './parse-phone-number'
import safeCheckValue from './safeCheckValue'
import secondsToDurationObject from './time/seconds-to-duration-object'
import durationObjectToString from './time/duration-object-to-string'

const filters = {
  metricScale,
  metricValidator,
  metricFeedback,
  fractionNumber,
  limitTo,
  roundROM,
  exerciseState,
  shDate,
  isNumber,
  sortNumeric,
  sortAlphabetically,
  sortByDate,
  sessionAndExerciseDuration,
  unitSystemFilters,
  parsePhoneNumber,
  safeCheckValue,
  secondsToDurationObject,
  durationObjectToString,
}

export default {
  install(Vue: VueConstructor) {
    for (const filter in filters) {
      Vue.filter(filter, filters[filter as keyof typeof filters])
    }
    Vue.prototype.$filters = Vue.options.filters
  },
}
